/* KALCODE assistant widget — shared by the inline section and the floating panel */
(function () {
  if (customElements.get('kalcode-assistant')) return;
  class KalcodeAssistant extends HTMLElement {
    connectedCallback() {
      this.endpoint = this.dataset.endpoint; this.name = this.dataset.name || 'KALCODE'; this.history = []; this.leadSaved = false;
      this.form = this.querySelector('[ref="form"]'); this.input = this.querySelector('[ref="input"]'); this.thread = this.querySelector('[ref="thread"]');
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.ask(this.input.value); });
      this.querySelectorAll('.kai__chip').forEach((b) => b.addEventListener('click', () => { this.input.value = b.dataset.q; this.ask(b.dataset.q); }));
      if (this.dataset.welcome) this.bubble('bot', `<span class="kai__who">${this.esc(this.name)}</span>${this.esc(this.dataset.welcome)}`);
    }
    esc(s) { return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
    bubble(role, html) {
      const el = document.createElement('div'); el.className = 'kai__msg kai__msg--' + role; el.innerHTML = html;
      this.thread.hidden = false; this.thread.appendChild(el); el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); return el;
    }
    renderAnswer(d) {
      const text = this.esc(d.answer).replace(/\n/g, '<br>');
      let cards = '';
      if (Array.isArray(d.products) && d.products.length) {
        cards = '<div class="kai__cards">' + d.products.map((p) => `<a class="kai__card" href="${this.esc(p.url)}">${p.image ? `<img src="${this.esc(p.image)}" alt="" loading="lazy">` : ''}<span class="kai__card-title">${this.esc(p.title)}</span>${p.price ? `<span class="kai__card-price">${this.esc(p.price)}</span>` : ''}</a>`).join('') + '</div>';
      }
      const lead = d.lead_saved && !this.leadSaved ? '<div class="kai__lead">✓ Got it — your details are with our team. We\'ll be in touch shortly.</div>' : '';
      if (d.lead_saved) this.leadSaved = true;
      return `<span class="kai__who">${this.esc(this.name)}</span>${text}${cards}${lead}`;
    }
    async ask(q) {
      q = (q || '').trim(); if (!q) return;
      if (!this.endpoint) { this.bubble('bot', `<span class="kai__who">${this.esc(this.name)}</span>The assistant isn't connected yet. Please check back soon.`); return; }
      this.bubble('user', this.esc(q)); this.input.value = ''; this.input.disabled = true;
      const pending = this.bubble('bot', `<span class="kai__who">${this.esc(this.name)}</span><span class="kai__dots"><i></i><i></i><i></i></span>`);
      try {
        const res = await fetch(this.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ question: q, history: this.history.slice(-12), page: location.pathname }) });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        pending.innerHTML = this.renderAnswer(data);
        this.history.push({ role: 'user', content: q }, { role: 'assistant', content: data.answer || '' });
      } catch (e) {
        pending.innerHTML = `<span class="kai__who">${this.esc(this.name)}</span>Sorry, something went wrong. Please try again in a moment.`;
      } finally { this.input.disabled = false; this.input.focus(); }
    }
  }
  customElements.define('kalcode-assistant', KalcodeAssistant);
})();
